import React from 'react';
import { useRouteError, useNavigate } from 'react-router-dom';
import { Result, Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../GlobalContext/ThemeContext';

const { Paragraph, Text } = Typography;

const RouteErrorFallback = () => {
    const error = useRouteError();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { isDarkMode } = useTheme();

    // Log error for debugging (won't be visible to users)
    console.error('Route error caught by ErrorBoundary:', error);

    const handleReload = () => {
        window.location.reload();
    };

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '60vh',
                padding: '24px',
            }}
        >
            <Result
                status="error"
                title={t('something_went_wrong', { defaultValue: 'Something went wrong' })}
                subTitle={t('error_occurred_message', {
                    defaultValue: 'We encountered an unexpected error. Please try reloading the page.'
                })}
                extra={[
                    <Button type="primary" key="reload" onClick={handleReload}>
                        {t('reload_page', { defaultValue: 'Reload Page' })}
                    </Button>,
                    <Button key="home" onClick={handleGoHome}>
                        {t('go_to_dashboard', { defaultValue: 'Go to Dashboard' })}
                    </Button>,
                ]}
            >
                {process.env.NODE_ENV === 'development' && error && (
                    <div style={{
                        marginTop: '24px',
                        textAlign: 'left',
                        padding: '16px',
                        background: isDarkMode ? '#1f1f1f' : '#f5f5f5',
                        borderRadius: '8px',
                        maxWidth: '600px'
                    }}>
                        <Paragraph>
                            <Text type="secondary" strong>
                                {t('error_details', { defaultValue: 'Error Details (Development Only):' })}
                            </Text>
                        </Paragraph>
                        <Paragraph>
                            <Text code style={{ fontSize: '12px' }}>
                                {error.statusText || error.message || 'Unknown error'}
                            </Text>
                        </Paragraph>
                    </div>
                )}
            </Result>
        </div>
    );
};

export default RouteErrorFallback;
